module.exports = __webpack_public_path__ + "img/Upload(Button).afc991a6.svg";